import { apiBase } from "./api";

const getFromApiProxy = async (path, config) => {
  const response = config ? await apiBase.get(path, config) : await apiBase.get(path);
  return response.data;
};

const mapPeriodo = (periodo) => {
  const value = Number(periodo);
  const result = {
    periodo: String(periodo),
    filtro: "MES_ACTUAL",
    mes: null,
    geolocalizacionPeriodo: "mes",
  };

  if (Number.isNaN(value)) {
    return result;
  }

  if (value >= 1 && value <= 12) {
    result.filtro = "MES_ESPECIFICO";
    result.mes = value;
    result.geolocalizacionPeriodo = [
      "",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ][value];
    return result;
  }

  if (value === 13) {
    result.filtro = "HOY";
    result.geolocalizacionPeriodo = "dia";
    return result;
  }
  if (value === 14) {
    result.filtro = "ULTIMOS_7_DIAS";
    result.geolocalizacionPeriodo = "semana";
    return result;
  }
  if (value === 15) {
    result.filtro = "ULTIMOS_15_DIAS";
    result.geolocalizacionPeriodo = "quincena";
    return result;
  }
  if (value === 17) {
    result.filtro = "ULTIMO_MES";
    result.geolocalizacionPeriodo = "mes";
    return result;
  }

  return result;
};

export const getConsumos = async ({ page, size, periodo, tipo, idAfiliado, estado }) => {
  const params = new URLSearchParams();
  const mappedPeriodo = mapPeriodo(periodo);

  params.append("page", page);
  params.append("size", size);
  params.append("tipo", tipo);
  params.append("estado", estado);
  params.append("periodo", mappedPeriodo.periodo);
  params.append("filtro", mappedPeriodo.filtro);
  if (mappedPeriodo.mes !== null) {
    params.append("mes", mappedPeriodo.mes);
  }
  if(idAfiliado !== 0) {
    params.append("afiliadoId", idAfiliado);
  }

  return getFromApiProxy(`/api/visualizador/consumos?${params.toString()}`);
};

export const fetchDistribucionMensual = async ({periodo, idAfiliado, estado}) => {
  const params = new URLSearchParams();
  const mappedPeriodo = mapPeriodo(periodo);

  params.append("periodo", mappedPeriodo.periodo);
  params.append("filtro", mappedPeriodo.filtro);
  params.append("estado", estado);
  if (mappedPeriodo.mes !== null) {
    params.append("mes", mappedPeriodo.mes);
  }
  if (idAfiliado !== 0) {
    params.append("afiliadoId", idAfiliado)
  }
  return getFromApiProxy(`/api/visualizador/cantidad-mensual?${params.toString()}`);
};

export const fetchResumenGeneral = async (periodo, tipo, idAfiliado, estado, signal) => {
  const params = new URLSearchParams();
  const mappedPeriodo = mapPeriodo(periodo);
  const tipos = { 0: "TODOS", 1: "FARMACEUTICO", 2: "AMBULATORIO" };

  if (mappedPeriodo.mes !== null) {
    params.append("mes", mappedPeriodo.mes);
  } else {
    const rangos = {
      HOY: "DIA",
      ULTIMOS_7_DIAS: "SEMANA",
      ULTIMOS_15_DIAS: "QUINCE_DIAS",
      ULTIMO_MES: "MES",
      MES_ACTUAL: "MES_ACTUAL",
    };
    params.append("rangoPeriodo", rangos[mappedPeriodo.filtro]);
  }
  params.append("tipoConsumo", tipos[tipo] || "TODOS");
  if (idAfiliado !== 0) {
    params.append("afiliadoId", idAfiliado);
  }
  if (estado) {
    params.append("estado", estado);
  }

  return getFromApiProxy(`/api/consumos/resumen-consumos?${params.toString()}`, { signal });
};

export const fetchDistribucionGeografica = async (periodo, tipo, idAfiliado, estado, signal) => {
  const params = new URLSearchParams();
  params.append("periodo", String(periodo));
  if (estado) {
    params.append("estado", estado);
  }
  if (tipo !== 0) {
    params.append("tipo", tipo);
  }
  if (idAfiliado !== 0) {
    params.append("afiliadoId", idAfiliado);
  }

  return getFromApiProxy(`/api/visualizador/geolocalizacion?${params.toString()}`, { signal });
};
